import { ApiClient } from '@travel/api-client';

import { ServiceConditionResponse } from 'ServiceCondition-Types';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

export const fetchServiceConditions = (http: ApiClient): Promise<ServiceConditionResponse> =>
  http.get('/monterosa-api-dp/dp/jrdp/service-conditions', {
    ignoreCommonErrorHandler: true,
    timeout: MONTEROSA_API_TIMEOUT,
  });
